import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'
//import { useHistory } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import { Translation } from 'react-i18next'
import Snackbar from '@material-ui/core/Snackbar'
import { MySnackbarContentWrapper } from '../../utils/snackbar.utils'
import UserSelectorContainer from '../../containers/layout/userSelector.container'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import AddToInvoiceDialog from './addToInvoiceDialog.component'
import { scrollToTop } from '../../utils/scrollTo'
import mobileView from '../../utils/mobile.utils'
import store from '../../store'
import ExpenseRow from './expenseRow.component'
import AllowanceRow from './allowanceRow.component'
import DateTimeFormat from '../../utils/DateTimeFormat'
import NewExpense from '../../containers/expenses/newExpense.container'
import NewAllowance from '../../containers/expenses/newAllowance.container'
import ModalComponent from '../layout/modal.component'
import { cancelExpenseUpdate } from '../../actions'
import { cancelAllowanceUpdate } from '../../actions'

/**
 * @author Pragya Gupta
 */

class NewExpensesComponent extends React.Component {
  componentDidMount() {
    if (this.props.userType == 2) {
      this.props.getAdminUsersList()
    }
    this.props.getUserCompanyUpdateInfo()
    this.props.loadAllowanceCost(new Date().getFullYear())
    this.props.getInvoicesStart(this.props.selectedUser)
    this.props.getExpenseStart(this.props.selectedUser)
    scrollToTop()
  }

  render() {
    return <Expenses {...this.props} />
  }
}

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',

    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },

  tablecell: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: 'black',
    [theme.breakpoints.down('xs')]: {
      padding: 4
    }
  },
  button: {
    margin: theme.spacing(1)
  }
})

const Expenses = ({
  expensePages,
  expensePageChange,
  allowancePages,
  allowancePageChange,
  classes,
  showExpenseDialog,
  cancelExpenseDialog,
  showAllowanceDialog,
  cancelAllowanceDialog,
  closeWarnExpInvoiceSnackbar,
  showWarnExpInvoiceSnackbar,
  showExpDialog,
  showTravelDialog,
  showInvoiceInfoSuccess,
  showInvoiceInfoFailed,
  cancelInvoiceInfoDialog,
  showWarnAllowInvoiceSnackbar,
  closeWarnAllowInvoiceSnackbar,
  userType,
  expenses,
  selectedExpensePage,
  allowances,
  selectedAllowancePage,
  addExpensesToInvoice,
  updateInvoiceIdToExpense,
  addAllowancesToInvoice,
  updateInvoiceIdToAllowance,
  editAllowance,
  editExpense,
  showSnackbar,
  closeSnackbar,
  showFailSnackbar,
  errMessage
}) => {
  //const history = useHistory()
  const [selectedExpenses, setSelectedExpenses] = React.useState([])
  const [selectedAllowances, setSelectedAllowances] = React.useState([])
  const [selectedMileageAllowanceData, setSelectedMileageAllowanceData] =
    React.useState([])

  // State variables for modal control
  const [open, setOpen] = useState(false)
  const [selectedContent, setSelectedContent] = useState(null)
  const [selectedMaxWidth, setSelectedMaxWidth] = useState('sm')

  // Function to open modal with specific content and width
  const handleOpenForm = (component, width = 'sm') => {
    setSelectedContent(component)
    setSelectedMaxWidth(width)
    setOpen(true)
  }

  const handleClose = (event) => {
    if (event) {
      event.stopPropagation()
    }
    setOpen(false)
    setSelectedContent(null)
    setSelectedMaxWidth('sm')
    store.dispatch(cancelExpenseUpdate())
    store.dispatch(cancelAllowanceUpdate())
  }

  function handleViewAllowance(
    index,
    id,
    added_to_invoice,
    isCheckBox,
    isSelected
  ) {
    if (isCheckBox) {
      handleSelect(isSelected, id)
    } else {
      setOpen(true)

      store.dispatch(editAllowance(index, id))
      if (!added_to_invoice) {
        handleOpenForm(
          <NewAllowance
            showTravelCostsInfo={true}
            isReadOnly={true}
            setOpen={setOpen}
          />,
          '1080px'
        )
      }
    }
  }

  function handleViewExpense(
    index,
    invoice_expense_id,
    added_to_invoice,
    //id,
    isCheckBox,
    isSelected
  ) {
    if (isCheckBox) {
      handleSelect(isSelected, invoice_expense_id)
    } else {
      setOpen(true)

      store.dispatch(editExpense(index, invoice_expense_id))
      if (!added_to_invoice) {
        handleOpenForm(
          <NewExpense showTravelCostsInfo={true} isReadOnly={true} />,
          '1080px'
        )
      }
    }
  }

  function handleEditAllowance(index, id, added_to_invoice, event) {
    if (event && event.target.closest('input[type="checkbox"]')) {
      handleSelect(isSelected, id)
      return
    }
    setOpen(true)

    store.dispatch(editAllowance(index, id, added_to_invoice))
    if (!added_to_invoice) {
      handleOpenForm(
        <NewAllowance showTravelCostsInfo={false} isReadOnly={false} />,
        '1080px'
      )
    }
  }

  function handleEditExpense(
    index,
    invoice_expense_id,
    added_to_invoice,
    event
  ) {
    if (event && event.target.closest('input[type="checkbox"]')) {
      handleSelect(isSelected, id)
      return
    }
    setOpen(true)

    store.dispatch(editExpense(index, invoice_expense_id, added_to_invoice))
    if (!added_to_invoice) {
      handleOpenForm(
        <NewExpense showTravelCostsInfo={false} isReadOnly={false} />,
        '1080px'
      )
    }
  }

  function handleSelectExpense(isSelected, clickedId) {
    if (!isSelected) {
      setSelectedExpenses((old) => [...old, clickedId])
    } else {
      setSelectedExpenses((old) => old.filter((id) => id !== clickedId))
    }
  }

  function handleSelectAllowance(
    isSelected,
    clickedId,
    mileage_allowance_data
  ) {
    if (!isSelected) {
      setSelectedAllowances((old) => [...old, clickedId])
      setSelectedMileageAllowanceData((old) => [...old, mileage_allowance_data])
    } else {
      setSelectedAllowances((old) => old.filter((id) => id !== clickedId))
      setSelectedMileageAllowanceData((old) =>
        old.filter((el) => el.id !== mileage_allowance_data.id)
      )
    }
  }

  function clearExpenseSelection() {
    setSelectedExpenses(() => [])
  }

  function clearAllowanceSelection() {
    setSelectedAllowances(() => [])
    setSelectedMileageAllowanceData(() => [])
  }

  React.useEffect(() => {
    if (showSnackbar || showFailSnackbar) {
      setOpen(false)
    }
  }, [showSnackbar, showFailSnackbar])

  const hasInvalidSelectedAllowance = selectedMileageAllowanceData.some(
    (item) =>
      item.mileage_allowance === true && item?.distance && item.distance < 15
  )

  return (
    <Translation>
      {(t) => {
        return (
          <div className="container">
            <div className="row">
              {userType == 2 && <UserSelectorContainer></UserSelectorContainer>}
            </div>
            <div className="row">
              <div className="dashboard-content-header">
                <h1>{t('expences.h1')}</h1>
              </div>
            </div>
            <div className="row">
              <div className="dashboard-content-header">
                <div className="col-xs-12 col-sm-12 col-lg-12">
                  <div className="panel panel-default">
                    <div className="panel-heading">
                      <h3 className="panel-title">{t('expences.h3')}</h3>
                    </div>
                    <div className="panel-body pd-0">
                      {expenseRows(
                        classes,
                        expenses,
                        expensePages,
                        expensePageChange,
                        selectedExpensePage,
                        selectedExpenses,
                        handleSelectExpense,
                        handleOpenForm,
                        handleClose,
                        handleViewExpense,
                        handleEditExpense
                      )}
                    </div>
                    <div className="panel-footer is-plain clearfix">
                      <div className="button-pull">
                        <Button
                          variant="outlined"
                          className={classes.button}
                          onClick={() =>
                            handleOpenForm(<NewExpense />, '1080px')
                          }
                          disabled={
                            userType == 2 &&
                            store.getState().adminUser.selectedUser.email ==
                              undefined
                              ? true
                              : false
                          }
                        >
                          {t('expences.label')}
                        </Button>
                        <Button
                          variant="contained"
                          className={classes.button}
                          type="submit"
                          onClick={() => showExpenseDialog(selectedExpenses)}
                          disabled={
                            userType == 2 &&
                            store.getState().adminUser.selectedUser.email ==
                              undefined
                              ? true
                              : false
                          }
                        >
                          {t('expences.label3')}
                        </Button>
                        <ModalComponent
                          open={open}
                          onClose={handleClose}
                          content={selectedContent}
                          maxWidth={selectedMaxWidth}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="dashboard-content-header">
                <h1>{t('expences.h1a')}</h1>
              </div>
            </div>
            <div className="row">
              <div className="dashboard-content-header">
                <div className="col-xs-12 col-sm-12 col-lg-12">
                  <div className="panel panel-default">
                    <div className="panel-heading">
                      <h3 className="panel-title">{t('expences.h3a')}</h3>
                    </div>
                    <div className="panel-body pd-0">
                      {allowanceRows(
                        classes,
                        allowances,
                        allowancePages,
                        allowancePageChange,
                        selectedAllowancePage,
                        selectedAllowances,
                        handleSelectAllowance,
                        handleOpenForm,
                        handleClose,
                        handleViewAllowance,
                        handleEditAllowance
                      )}
                    </div>
                    <div className="panel-footer is-plain clearfix">
                      <div className="button-pull">
                        <Button
                          variant="outlined"
                          className={classes.button}
                          /*             onClick={() => {
                            history.push('/dashboard/fee/newallowance')
                          }} */
                          onClick={() =>
                            handleOpenForm(<NewAllowance />, '1080px')
                          }
                          disabled={
                            userType == 2 &&
                            store.getState().adminUser.selectedUser.email ==
                              undefined
                              ? true
                              : false
                          }
                        >
                          {t('expences.label2')}
                        </Button>
                        <Button
                          variant="contained"
                          className={classes.button}
                          onClick={() =>
                            showAllowanceDialog(selectedAllowances)
                          }
                          disabled={
                            userType == 2 &&
                            store.getState().adminUser.selectedUser.email ==
                              undefined
                              ? true
                              : false
                          }
                        >
                          {t('expences.label4')}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="dashboard-content-header">
                <div className="col-xs-12 col-sm-12 col-lg-12">
                  <div className="panel panel-default">
                    <div className="panel-heading">
                      <h3 className="panel-title">{t('expences.info')}</h3>
                    </div>
                    <div className="panel-body">
                      <p>{t('expences.p1')}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={showSnackbar}
              autoHideDuration={2000}
              onClose={() => {
                closeSnackbar()
                // history.push('/dashboard/fee')
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeSnackbar()
                  // history.push('/dashboard/fee')
                }}
                variant="success"
                message={t('newAllowComponent.msg')}
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'center'
              }}
              open={showFailSnackbar}
              autoHideDuration={2000}
              onClose={() => {
                //store.dispatch(editAllowance(null, id)) --> NOT needed: commenting out because 'id' passed is always undefined (retaining for future reference)
                closeSnackbar()
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  //store.dispatch(editAllowance(null, id))
                  closeSnackbar()
                }}
                variant="error"
                message={
                  errMessage ===
                  'Error: Miles allowances box checked, and no vehicle type was selected'
                    ? t('newAllowComponent.vehicleFailMsg')
                    : t('newAllowComponent.failMsg')
                }
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'center'
              }}
              open={showWarnExpInvoiceSnackbar}
              autoHideDuration={2000}
              onClose={() => {
                closeWarnExpInvoiceSnackbar()
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeWarnExpInvoiceSnackbar()
                }}
                variant="success"
                message={t('expences.msgInvExpWarn')}
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'center'
              }}
              open={showWarnAllowInvoiceSnackbar}
              autoHideDuration={2000}
              onClose={() => {
                closeWarnAllowInvoiceSnackbar()
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeWarnAllowInvoiceSnackbar()
                }}
                variant="success"
                message={t('expences.msgInvAllowWarn')}
              />
            </Snackbar>
            <Dialog
              open={showExpDialog}
              onClose={() => {
                cancelExpenseDialog()
                clearExpenseSelection()
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogActions>
                <AddToInvoiceDialog
                  type="expense"
                  selected={selectedExpenses}
                  clearSelection={clearExpenseSelection}
                  addToInvoice={addExpensesToInvoice}
                  updateToInvoice={updateInvoiceIdToExpense}
                  cancelDialog={cancelExpenseDialog}
                />
              </DialogActions>
            </Dialog>
            <Dialog
              open={showTravelDialog}
              onClose={() => {
                cancelAllowanceDialog()
                clearAllowanceSelection()
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogActions>
                <AddToInvoiceDialog
                  type="allowance"
                  selected={selectedAllowances}
                  clearSelection={clearAllowanceSelection}
                  addToInvoice={addAllowancesToInvoice}
                  updateToInvoice={updateInvoiceIdToAllowance}
                  cancelDialog={cancelAllowanceDialog}
                  hasInvalidSelectedAllowance={hasInvalidSelectedAllowance}
                />
              </DialogActions>
            </Dialog>

            <Dialog
              open={showInvoiceInfoSuccess}
              onClose={() => cancelInvoiceInfoDialog()}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                <span style={{ fontSize: '20px' }}>
                  {t('decisionDialog.dialogSuccessTitle')}
                </span>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <span style={{ fontSize: '14px' }}>
                    {t('decisionDialog.dialogSuccessMsg')}
                  </span>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <div className="pull-right">
                  <Button
                    variant="outlined"
                    className={classes.button}
                    onClick={() => cancelInvoiceInfoDialog()}
                  >
                    {t('decisionDialog.dialogBtn')}
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
            <Dialog
              open={showInvoiceInfoFailed}
              onClose={() => cancelInvoiceInfoDialog()}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <span style={{ fontSize: '16px' }}>
                    {t('decisionDialog.dialogFailedMsg')}
                  </span>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <div className="pull-right">
                  <Button
                    variant="outlined"
                    className={classes.button}
                    onClick={() => cancelInvoiceInfoDialog()}
                  >
                    {t('decisionDialog.dialogBtn')}
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
          </div>
        )
      }}
    </Translation>
  )
}

const expenseRows = (
  classes,
  expenses,
  expensePages,
  expensePageChange,
  selectedExpensePage,
  selectedExpenses,
  handleSelectExpense,
  handleOpenForm,
  handleClose,
  handleViewExpense,
  handleEditExpense
) => (
  <Translation>
    {(t) => {
      return (
        <div className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell
                  padding="checkbox"
                  className={mobileView ? classes.tablecell : null}
                ></TableCell>
                <TableCell
                  className={classNames(classes.tablecell, 'hide-mobile')}
                >
                  {t('expences.table')}
                </TableCell>
                <TableCell className={classes.tablecell}>
                  {t('expences.table1')}
                </TableCell>
                <TableCell
                  className={classNames(classes.tablecell, 'hide-mobile')}
                >
                  {t('expences.table2')}
                </TableCell>
                <TableCell
                  className={classNames(classes.tablecell, 'hide-mobile')}
                >
                  {t('expences.table3')}
                </TableCell>
                <TableCell className={classes.tablecell}>
                  {t('expences.table4')}
                </TableCell>
                <TableCell className={classes.tablecell}>
                  {t('expences.table5')}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {store.getState().adminUser.clearUserInfo
                ? []
                : _createExpenseRow(
                    expenses,
                    selectedExpensePage,
                    selectedExpenses,
                    handleSelectExpense,
                    handleOpenForm,
                    handleClose,
                    handleViewExpense,
                    handleEditExpense
                  )}
            </TableBody>
          </Table>
          <Divider />
          <ReactPaginate
            previousLabel={<i className="fa fa-chevron-left" />}
            nextLabel={<i className="fa fa-chevron-right" />}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={expensePages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={expensePageChange}
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
          />
        </div>
      )
    }}
  </Translation>
)

const _createExpenseRow = (
  expenses,
  selected,
  selectedExpenses,
  handleSelect,
  handleOpenForm,
  handleClose,
  handleViewExpense,
  handleEditExpense
) =>
  expenses.slice(selected * 10, selected * 10 + 10).map((el, index) => (
    <ExpenseRow
      index={index}
      added_to_invoice={el.added_to_invoice}
      key={el.invoice_expense_id}
      company_name={el.company_name}
      invoice_id={el.invoice_id}
      date_of_purchase={new DateTimeFormat('fi', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
      }).format(new Date(el.date_of_purchase))}
      place_of_purchase={el.place_of_purchase}
      sum={new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(el.sum)}
      invoice_expense_id={el.invoice_expense_id}
      handleSelect={handleSelect}
      isSelected={selectedExpenses.some((id) => id === el.invoice_expense_id)}
      handleOpenForm={handleOpenForm}
      handleClose={handleClose}
      handleViewExpense={handleViewExpense}
      handleEditExpense={handleEditExpense}
    />
  ))

const allowanceRows = (
  classes,
  allowances,
  allowancePages,
  allowancePageChange,
  selectedAllowancePage,
  selectedAllowances,
  handleSelectAllowance,
  handleOpenForm,
  handleClose,
  handleViewAllowance,
  handleEditAllowance
) => (
  <Translation>
    {(t) => {
      return (
        <div className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell
                  padding="checkbox"
                  className={mobileView ? classes.tablecell : null}
                ></TableCell>
                <TableCell
                  className={classNames(classes.tablecell, 'hide-mobile')}
                >
                  {t('expences.table6')}
                </TableCell>
                <TableCell className={classes.tablecell}>
                  {t('expences.table6a')}
                </TableCell>
                <TableCell
                  className={classNames(classes.tablecell, 'hide-mobile')}
                >
                  {t('expences.table7')}
                </TableCell>
                <TableCell
                  className={classNames(classes.tablecell, 'hide-mobile')}
                >
                  {t('expences.table8')}
                </TableCell>
                <TableCell className={classes.tablecell}>
                  {t('expences.table9')}
                </TableCell>
                <TableCell className={classes.tablecell}>
                  {t('expences.table10')}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {store.getState().adminUser.clearUserInfo
                ? []
                : _createAllowanceRow(
                    allowances,
                    selectedAllowancePage,
                    selectedAllowances,
                    handleSelectAllowance,
                    handleOpenForm,
                    handleClose,
                    handleViewAllowance,
                    handleEditAllowance
                  )}
            </TableBody>
          </Table>
          <Divider />
          <ReactPaginate
            previousLabel={<i className="fa fa-chevron-left" />}
            nextLabel={<i className="fa fa-chevron-right" />}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={allowancePages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={allowancePageChange}
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
          />
        </div>
      )
    }}
  </Translation>
)

const _createAllowanceRow = (
  allowances,
  selected,
  selectedAllowances,
  handleSelect,
  handleOpenForm,
  handleClose,
  handleViewAllowance,
  handleEditAllowance
) =>
  allowances.slice(selected * 10, selected * 10 + 10).map((el, index) => (
    <AllowanceRow
      index={index}
      isChecked={el.isChecked}
      added_to_invoice={el.added_to_invoice}
      key={el.id}
      id={el.id}
      company_name={el.company_name}
      invoice_id={el.invoice_id}
      start_date={new DateTimeFormat('fi', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
      }).format(new Date(el.start_date))}
      end_date={new DateTimeFormat('fi', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
      }).format(new Date(el.end_date))}
      sum={new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(el.sum_total_allowance)}
      handleSelect={handleSelect}
      isSelected={selectedAllowances.some((id) => id === el.id)}
      handleOpenForm={handleOpenForm}
      handleClose={handleClose}
      handleViewAllowance={handleViewAllowance}
      handleEditAllowance={handleEditAllowance}
      mileage_allowance={el.mileage_allowance}
      distance={el.distance}
    />
  ))

NewExpensesComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(NewExpensesComponent)
